/* globals jQuery */

export default function( endpoint, data, callback, method ) {
	data = data || {};
	data.endpoint = endpoint;

	var args = {
		method: method || 'GET',
		url: '/api.php',
		data,
		dataType: 'json',
		success: resp => {
			callback( resp );
		},
		error: err => {
			alert( 'Unknown error handling request. ' + err.responseText );
			flutterDebug( 'api', err.responseText );
		},
	};

	jQuery.ajax( args );
}
